var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketPubli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "var(--main-forte)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 23.3333V14M22.3333 23.3333L29.4527 27.4015C29.9194 27.6682 30.5 27.3312 30.5 26.7938V10.5395C30.5 10.0021 29.9194 9.6651 29.4527 9.93177L22.3333 14M22.3333 23.3333H14.1667C11.5893 23.3333 9.5 21.2439 9.5 18.6666C9.5 16.0893 11.5893 14 14.1667 14H22.3333",
    stroke: "#1975FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.05 29.5168L14.1667 23.3334H18.8334L19.6234 28.8635C19.8222 30.2551 18.7424 31.5 17.3367 31.5C16.1872 31.5 15.2126 30.6548 15.05 29.5168Z",
    stroke: "#1975FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketPubli);
export default __webpack_public_path__ + "static/media/market_publi.233d5fe65e21405dc9416473c3c74438.svg";
export { ForwardRef as ReactComponent };